// Gmail deep links that open in the RIGHT Google account.
//
// The naive `https://mail.google.com/mail/u/0/...` pins the link to `/u/0/` -
// the FIRST Google account signed into the browser, which is positional. An
// operator also signed into a personal account lands there instead. Gmail
// accepts an email in the `/u/<account>/` slot and resolves it to that account,
// sign-in-order independent. We put the email THERE (not in a `?authuser=`
// query) deliberately: a query param before the `#all/<threadId>` fragment can
// be dropped during Gmail's account-switch redirect. `@`/`.` are legal
// unencoded in a URL path, and percent-encoding would deviate from Google's
// documented `/mail/u/<email>/` form. (No URL can open a mailbox the browser
// isn't signed into; Gmail then shows its account picker.)
const accountBase = (accountEmail: string | null | undefined): string =>
  `https://mail.google.com/mail/u/${accountEmail || "0"}/`;

// `accountEmail` is the inbox the thread was read from (`gmail_account_email`
// on the uploads tree).
export function gmailThreadUrl(
  threadId: string | null | undefined,
  accountEmail?: string | null,
): string | null {
  if (!threadId) return null;
  return `${accountBase(accountEmail)}#all/${threadId}`;
}

// Same shape as the backend's `drafts._ADDRESS_RE`.
export const ADDRESS_RE = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g;

// The bare addresses on a To or Cc line. Agents write it as prose ("Georgina
// Taylor, ESP Electricity - generation@espug.com"), which is no address header.
export const emailAddresses = (to: string): string[] => [
  ...new Set(to.match(ADDRESS_RE) ?? []),
];

// A draft in the operator's Drafts, opened for editing.
export const gmailDraftUrl = (
  messageId: string,
  accountEmail: string | null | undefined,
): string => `${accountBase(accountEmail)}#drafts?compose=${messageId}`;
